import React from "react";
import { Grid, Typography, FormGroup } from "@mui/material";
import CustomSelect from "../select field/OutlinedSelectField";
import OutlinedInputField from "./OutlinedInput";
import { ThemeColor } from "../theme/color";
import { fontSize } from "../theme/fontSize";
import { FontFamily } from "../theme/fontFamily";
import { fontWeight } from "../theme/fontWeight";

// Country codes list
const countryCodes = [
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+86", country: "China" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+39", country: "Italy" },
  { code: "+34", country: "Spain" },
  { code: "+7", country: "Russia" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" },
  { code: "+971", country: "UAE" },
  { code: "+65", country: "Singapore" },
];

// Helper function to parse phone number and extract country code
const parsePhoneNumber = (phone) => {
  if (!phone) return { countryCode: "+1", number: "" };

  const phoneStr = String(phone);
  // Check if phone starts with +
  if (phoneStr.startsWith("+")) {
    // Find matching country code
    for (const cc of countryCodes) {
      if (phoneStr.startsWith(cc.code)) {
        return {
          countryCode: cc.code,
          number: phoneStr.substring(cc.code.length),
        };
      }
    }
  }
  // Default if no country code found
  return { countryCode: "+1", number: phoneStr };
};

// Helper function to merge country code and phone number
const mergePhoneNumber = (countryCode, number) => {
  return countryCode + number;
};

const PhoneInputWithCountryCode = ({
  label,
  value,
  name,
  onChange,
  placeholder = "Enter phone",
  error,
  fullWidth = true,
}) => {
  const parsedPhone = parsePhoneNumber(value);

  const handleCountryCodeChange = (e) => {
    const newCountryCode = e.target.value;
    const mergedPhone = mergePhoneNumber(newCountryCode, parsedPhone.number);
    
    // Create synthetic event for Formik
    const syntheticEvent = {
      target: {
        name: name,
        value: mergedPhone,
      },
    };
    onChange(syntheticEvent);
  };

  const handlePhoneNumberChange = (e) => {
    const newNumber = e.target.value;
    const mergedPhone = mergePhoneNumber(parsedPhone.countryCode, newNumber);
    
    // Create synthetic event for Formik
    const syntheticEvent = {
      target: {
        name: name,
        value: mergedPhone,
      },
    };
    onChange(syntheticEvent);
  };

  return (
    <FormGroup>
      <div className="">
        {label && (
          <Typography
            className="mb-2"
            sx={{
              fontWeight: 520,
              fontSize: "0.9rem",
              letterSpacing: "0.00938em",
              fontFamily: "Lato !important",
            }}
          >
            {label}
          </Typography>
        )}
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <CustomSelect
              value={parsedPhone.countryCode}
              onChange={handleCountryCodeChange}
              displayEmpty
              option={countryCodes.map((cc) => ({ _id: cc.code, title: cc.code }))}
              label={"Code"}
            />
          </Grid>
          <Grid item xs={8}>
            <OutlinedInputField
              value={parsedPhone.number}
              name={name}
              onChange={handlePhoneNumberChange}
              placeholder={placeholder}
              fullWidth={fullWidth}
              helperText={
                error && (
                  <Typography
                    align="left"
                    color={ThemeColor.RED}
                    fontSize={fontSize.h4.medium}
                    fontFamily={FontFamily.Lato}
                    fontWeight={fontWeight.W500}
                  >
                    {error}
                  </Typography>
                )
              }
            />
          </Grid>
        </Grid>
      </div>
    </FormGroup>
  );
};

export default PhoneInputWithCountryCode;
